"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lstat = exports.readdir = void 0;
exports.find = find;
const fs_1 = require("fs");
const path_1 = require("path");
const common_1 = require("./common");
const debug_1 = require("./debug");
const extract_1 = require("./extract");
const minimatch = require("minimatch");
exports.readdir = fs_1.promises.readdir, exports.lstat = fs_1.promises.lstat;
async function find(src, excludePatterns = []) {
    const fileResults = [];
    const archiveResults = [];
    const handler = async (path, stats) => {
        if (!(0, common_1.isSupportedSize)(stats.size)) {
            return;
        }
        if ((0, extract_1.isArchive)(path)) {
            archiveResults.push(path);
            return;
        }
        fileResults.push(path);
    };
    const isExcluded = (path) => {
        return !!excludePatterns.find((pattern) => minimatch(path, pattern));
    };
    await traverse(src, handler, isExcluded);
    return [fileResults, archiveResults];
}
async function traverse(src, handle, isExcluded) {
    try {
        if (isExcluded(src)) {
            return;
        }
        const stats = await (0, exports.lstat)(src);
        if (stats.isSymbolicLink()) {
            return;
        }
        if (stats.isFile()) {
            handle(src, stats);
            return;
        }
        if (stats.isDirectory()) {
            const entries = await (0, exports.readdir)(src);
            for (const entry of entries) {
                const absolute = (0, path_1.join)(src, entry);
                await traverse(absolute, handle, isExcluded);
            }
        }
    }
    catch (error) {
        (0, debug_1.debug)(error.message || `Error reading file ${src}. ${error}`);
    }
}
//# sourceMappingURL=find.js.map